module.exports = __webpack_public_path__ + "static/media/machismo_jose_arturo.0f840e22.png";